import { DialogTemplate } from "src/app/_models/body"
import { InputFieldType } from "src/app/common/constants"

export const VoiceCloneTemplate = (langCodeOptions: string[]): DialogTemplate => {
    return {
        dialogTitle: 'Create Voice Clone',
        dialogFields: [
            {
                key: 'speakerName',
                label: `Speaker Name (e.g. 'Will Smith', 'Michael Jaskson')`,
                type: InputFieldType.Text,
                size: 24,
                required: true,
                errorKey: 'pattern',
            },
            {
                key: 'langCode',
                label: 'Language Code',
                type: InputFieldType.Selector,
                size: 24,
                required: true,
                options: langCodeOptions,
                isClearDisabled: true
            },
            {
                key: 'files',
                label: 'Audio files (max 15s/file, 90s total, 20MB total)',
                type: InputFieldType.Uploader,
                size: 24,
                required: true,
                mode: 'multiple',
                accept: 'audio/*, application/octet-stream',
                withGuid: false
            }
        ]
    }
}